import * as React from 'react';
import { ProgressBar, Panel } from 'react-bootstrap';
import { DocUpload, DocUploadSteps } from '../../common/models';

import './DocUploadPanel.css';

interface DocUploadPanelProps {
  docUpload: DocUpload;
}

export const DocUploadPanel = ({ docUpload }: DocUploadPanelProps) => {
  return (
    <Panel className="DocUploadPanel">
      <Panel.Body>
        <h3>{docUpload.file.name}{' '}
          {!docUpload.error && docUpload.step.code !== DocUploadSteps.DONE.code &&
            <small className="pull-right">{docUpload.step.message}</small>
          }
          {!docUpload.error && docUpload.step.code === DocUploadSteps.DONE.code &&
            <small className="pull-right text-success">
              {docUpload.step.message}{' '}<i className="fa fa-lg fa-check"/>
            </small>
          }
          {docUpload.error &&
            <small className="text-danger pull-right">
              {docUpload.step.failMessage + ' (' + docUpload.error.message + ') '}<i className="fa fa-lg fa-times"/>
            </small>
          }
        </h3>
        {docUpload.step.code === DocUploadSteps.DONE.code ?
          <ProgressBar now={docUpload.percentComplete} bsStyle="success"/> : (
            docUpload.error ?
              <ProgressBar now={docUpload.percentComplete} bsStyle="danger"/> :
              <ProgressBar active={true} now={docUpload.percentComplete}/>
          )
        }
      </Panel.Body>
    </Panel>
  );
};



// WEBPACK FOOTER //
// ./src/DocUploaderView/DocUploadPanel/DocUploadPanel.tsx